<div class="table-wrapper">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && tableData.length === 0" class="empty-container">
    <p>{{ 'simulationBuilder.NO_SIMULATIONS_FOUND' | transloco }}</p>
  </div>

  <!-- Data Loaded State -->
  <qai-table
    *ngIf="!isLoading && tableData.length > 0"
    [headers]="headers"
    [data]="tableData"
    [striped]="false"
    [isTooltipLoading]="isTooltipLoading"
    (tooltipDataRequested)="onTooltipDataRequested($event)"
    [initialSortColumn]="initialSortColumn"
    [initialSortDirection]="initialSortDirection"
    [previousLabel]="'simulationBuilder.PAGINATION_PREVIOUS' | transloco"
    [nextLabel]="'simulationBuilder.PAGINATION_NEXT' | transloco"
  ></qai-table>
</div>
